<script>
import FormItemPhone from '@components/form-item-phone.vue'
import { putPromptOptInMarketingTexts } from '@src/api/marketingTexts'
import { isMobileMixin } from '@src/mixins/isMobileMixin'
import MobileTerms from '@components/mobile-terms.vue'

export default {
  components: {
    FormItemPhone,
    MobileTerms,
  },
  mixins: [isMobileMixin],
  props: {
    mobileNumber: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalMobileNumber: this.mobileNumber,
      acceptedMobileOptInData: [],
      hasOptedInSMSModal: [],
    }
  },
  watch: {
    mobileNumber: {
      handler: function (newVal) {
        this.modalMobileNumber = newVal
      },
    },
  },
  methods: {
    openPrivacyModal() {
      this.$root.$bvModal.hide('modal-opt-in-mobile-prompt')
      this.$root.$bvModal.show('modalPrivacy')
    },
    closePrivacyModal() {
      this.$root.$bvModal.hide('modalPrivacy')
      this.$root.$bvModal.show('modal-opt-in-mobile-prompt')
    },
    openMobileTermsModal() {
      this.$root.$bvModal.hide('modal-opt-in-mobile-prompt')
      this.$root.$bvModal.show('modalMobileTerms')
    },
    closeMobileTermsModal() {
      this.$root.$bvModal.hide('modalMobileTerms')
      this.$root.$bvModal.show('modal-opt-in-mobile-prompt')
    },

    openMobileTerms() {
      if (this.isMobile) {
        this.openMobileTermsModal()
        return
      }
      const redirectUrl = this.$router.resolve({ name: 'mobileTerms' }).href
      window.open(redirectUrl, '_blank')
    },
    handleOptInCancel() {
      this.$emit('cancel-opt-in')
      this.hasOptedInSMSModal = []
    },
    handleOptInOk() {
      this.$emit('update:mobile-number', this.modalMobileNumber)
      this.$emit('ok-opt-in', !!this.hasOptedInSMSModal[0])
      this.hasOptedInSMSModal = []
    },
    async handleHomeOptInCancel(bvCancelEvent) {
      bvCancelEvent.preventDefault()
      try {
        await putPromptOptInMarketingTexts({
          optInToMarketingTexts: false,
        })
        this.$root.$bvToast.toast(
          `No problem, if you change your mind you can sign up for text messaging in your Profile.`,
          {
            toaster: 'b-toaster-bottom-center',
            toastClass: 'toast-primary-blue',
          }
        )
      } catch (e) {
        this.$root.$bvToast.toast('There was an error trying to save your notification preferences.', {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      } finally {
        this.$root.$bvModal.hide('modalHomeConfirmOptInMobilePrompt')
        this.$root.$bvModal.hide('modalHomeOptInMobilePrompt')
      }
    },
    async handleHomeOptInOk(bvOkEvent) {
      bvOkEvent.preventDefault()
      try {
        await putPromptOptInMarketingTexts({
          phoneMobile: this.modalMobileNumber,
          optInToMarketingTexts: !!this.acceptedMobileOptInData[0],
        })
        this.$root.$bvToast.toast(`You have successfully signed up for text messaging from Motto HQ.`, {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-success',
        })
      } catch (e) {
        this.$root.$bvToast.toast('There was an error trying to save your notification preferences.', {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      } finally {
        this.$root.$bvModal.hide('modalHomeOptInMobilePrompt')
      }
    },
  },
}
</script>

<template>
  <div>
    <ValidationObserver ref="modal-opt-in" v-slot="{ failed: validationFailed }" immediate>
      <b-modal
        id="modal-opt-in-mobile-prompt"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        title="SMS - MottoMortgage Network Alerts"
        header-class="text-center"
        modal-class="form-modal modal-title-centered"
        cancel-title="Decline"
        ok-title="Confirm"
        :ok-disabled="validationFailed || _.isEmpty(modalMobileNumber)"
        :centered="true"
        @cancel="handleOptInCancel"
        @ok="handleOptInOk">
        <div>
          <div class="mt-4">
            <p class="p1">
              Opt in to receive important messages regarding marketing, events, and general information about tools,
              services, and support of the Motto Mortgage network. Message frequency varies. Text HELP to 58476 or call
              866-668-8660 for help, STOP to 58476 to end. Message and Data rates may apply. By opting in, you authorize
              Motto Mortgage to deliver marketing messages using an automatic telephone dialing system. You are not
              required to opt in as a condition of purchasing any property, goods, or services. By checking the box
              below, you agree to the
              <RouterLink
                :to="{ name: 'mobileTerms' }"
                class="button-text text-decoration-none color-primary-blue"
                target="_blank"
                >MOBILE TERMS OF USE</RouterLink
              >
              and
              <a
                href="https://www.mottomortgage.com/privacy-policy"
                target="_blank"
                class="button-text text-decoration-none color-primary-blue"
                >Motto Mortgage Privacy Policy</a
              >
              and
              <RouterLink
                :to="{ name: 'userAgreement' }"
                target="_blank"
                class="button-text text-decoration-none color-primary-blue"
                >USER AGREEMENT</RouterLink
              >.
            </p>
            <div :class="$style.optInMobileNumberContainer" class="d-flex mt-3 align-items-center">
              <ValidationProvider :name="'optInMobile'">
                <FormItemPhone
                  :class="$style.notificationPhoneSms"
                  class="mt-2 mb-4"
                  phone-label="Mobile Number"
                  edit-mode
                  hide-ext
                  :disabled="!hasOptedInSMSModal[0]"
                  :options="{ hideAsterisk: true }"
                  phone-placeholder="Mobile Number"
                  :phone.sync="modalMobileNumber"
                  :rules="'required|validPhoneNumber'" />
                <BaseCheckbox
                  v-model="hasOptedInSMSModal"
                  label="I’d like to receive text messages from Motto HQ."
                  input-value="1" />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </b-modal>
    </ValidationObserver>
    <ValidationObserver ref="modal-home-opt-in" v-slot="{ failed: validationFailedHome }" immediate>
      <b-modal
        id="modalHomeOptInMobilePrompt"
        no-close-on-backdrop
        no-close-on-esc
        header-close-content="Skip"
        modal-class="form-modal modal-title-centered"
        cancel-title="Decline"
        header-class="text-center"
        title="SMS - MottoMortgage Network Alerts"
        ok-title="Confirm"
        :ok-disabled="!acceptedMobileOptInData[0] || validationFailedHome || _.isEmpty(modalMobileNumber)"
        :centered="true"
        @close="handleHomeOptInCancel"
        @cancel="handleHomeOptInCancel"
        @ok="handleHomeOptInOk">
        <div>
          <div class="mt-4">
            <p class="p1">
              Opt in to receive important messages regarding marketing, events, and general information about tools,
              services, and support of the Motto Mortgage network. Message frequency varies. Text HELP to 58476 or call
              866-668-8660 for help, STOP to 58476 to end. Message and Data rates may apply. By opting in, you authorize
              Motto Mortgage to deliver marketing messages using an automatic telephone dialing system. You are not
              required to opt in as a condition of purchasing any property, goods, or services. By checking the box
              below, you agree to the
              <RouterLink
                :to="{ name: 'mobileTerms' }"
                class="button-text text-decoration-none color-primary-blue"
                target="_blank"
                >MOBILE TERMS OF USE</RouterLink
              >
              and
              <a
                href="https://www.mottomortgage.com/privacy-policy"
                target="_blank"
                class="button-text text-decoration-none color-primary-blue"
                >Motto Mortgage Privacy Policy</a
              >
              and
              <RouterLink
                :to="{ name: 'userAgreement' }"
                target="_blank"
                class="button-text text-decoration-none color-primary-blue"
                >USER AGREEMENT</RouterLink
              >.
            </p>
            <div :class="$style.optInMobileNumberContainer" class="d-flex mt-3 align-items-center">
              <ValidationProvider :name="'optInMobile'">
                <FormItemPhone
                  :class="$style.notificationPhoneSms"
                  class="mt-2 mb-4"
                  phone-label="Mobile Number"
                  edit-mode
                  hide-ext
                  :disabled="!hasOptedInSMSModal[0]"
                  :options="{ hideAsterisk: true }"
                  phone-placeholder="Mobile Number"
                  :phone.sync="modalMobileNumber"
                  :rules="'required|validPhoneNumber'" />
                <BaseCheckbox
                  v-model="acceptedMobileOptInData"
                  label="I’d like to receive text messages from Motto HQ."
                  input-value="1" />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </b-modal>
    </ValidationObserver>

    <b-modal
      id="modalPrivacy"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Opt-in to Receive text messages from Motto HQ"
      header-class="text-center"
      modal-class="confirmation-modal"
      ok-only
      ok-title="Ok"
      :centered="true"
      @ok="closePrivacyModal">
      <div :class="$style.privacyPolicyContainer"></div>
    </b-modal>
    <b-modal
      id="modalMobileTerms"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Opt-in to Receive text messages from Motto HQ"
      header-class="text-center"
      modal-class="confirmation-modal"
      ok-only
      ok-title="Ok"
      :centered="true"
      @ok="closeMobileTermsModal">
      <div :class="$style.privacyPolicyContainer">
        <MobileTerms />
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import '@design';

#modalHomeOptInMobilePrompt {
  .modal-header {
    button {
      font-size: 14px;
    }
  }
}
</style>

<style lang="scss" module>
@import '@design';

.openPrivacyPolicy {
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
}

.privacyPolicyContainer {
  max-height: 60vh;
  overflow-y: scroll;
}

.notificationPhoneSms {
  > div {
    > div {
      display: flex;
      align-items: baseline;

      > div {
        margin-right: 1em;
      }
    }
  }
}
</style>
